import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  TemplateRef
} from "@angular/core";

export type Column = {
  key: string;
  title: string;
  icon: string;
  tooltip: string;
  cards: any[];
  [key: string]: any;
};

@Component({
    selector: "app-driveb-kanban-column",
    templateUrl: "./kanban-column.component.html",
    styleUrls: ["./kanban-column.component.scss"],
    standalone: false
})
export class KanbanColumnComponent implements OnInit {
  @Input() title;
  @Input() icon;
  @Input() tooltip;
  @Input() key;
  @Input() cards;
  @Input() totalElements;
  @Input() cardTemplate?: TemplateRef<any>;
  @Output() reachedEnd = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  @HostListener("scroll", ["$event"]) onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    if (element.offsetHeight + element.scrollTop >= element.scrollHeight - 40) {
      this.reachedEnd.emit(this.key);
    }
  }
}
